export function isWine(category) {
    if (!category) {
        return false;
    }

    return category.parent_id === 4 || category.id === 4 ? true : false;
}
